import { render, staticRenderFns } from "./d-activity-repost.vue?vue&type=template&id=010b0b4a&scoped=true&"
import script from "./d-activity-repost.vue?vue&type=script&lang=js&"
export * from "./d-activity-repost.vue?vue&type=script&lang=js&"
import style0 from "./d-activity-repost.vue?vue&type=style&index=0&id=010b0b4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b0b4a",
  null
  
)

export default component.exports